<template>
	<section class="content checkout-content wp_AllPageMarginTop">
		<div class="coming-soon-w d-flex">
			<img
				src="/img/coming-soon.png"
				alt=""
				srcset=""
				class="mx-auto"
				style=" cursor: pointer"
				id="commingSoonImg"
				@click.prevent="$router.push('/')"
				data-test="commingSoonImg"
			>
		</div>
	</section>
</template>
<script>
export default {
	name: 'coming-soon'
}
</script>

<style lang="scss" scoped>
	.coming-soon-w {
		width: 100%;
		max-width: 400px;
		justify-content: center;
		margin: 7em auto 4em;
		padding: 1em;
		@media screen and (min-width: "992px") {
			max-width: 600px;
			margin-top: 2em;
		}
		img {
			width: 100%;
			height: auto;
		}
	}
</style>
